/// <amd-module name="NetSuite.ImageTextOverlay.ImageTextOverlayCCT.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("NetSuite.ImageTextOverlay.ImageTextOverlayCCT.View", ["require", "exports", "CustomContentType.Base.View", "netsuite_imagetextoverlay_imagetextoverlaycct.tpl", "jQuery", "NetSuite.ImageTextOverlay.Instrumentation.Helper"], function (require, exports, CustomContentTypeBaseView, netsuite_imagetextoverlay_imagetextoverlaycct_tpl, jQuery, Instrumentation_Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ImageTextOverlayCCTView = /** @class */ (function (_super) {
        __extends(ImageTextOverlayCCTView, _super);
        function ImageTextOverlayCCTView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = netsuite_imagetextoverlay_imagetextoverlaycct_tpl;
            _this.contextDataRequest = ['item'];
            _this.events = {
                'click [data-action="sc-imagetextoverlay-buttonpress"]': 'logButtonPress',
            };
            _this.IMG_ALIGN_MAP = {
                1: 'bg-center-top',
                2: 'bg-center-center',
                3: 'bg-center-bottom',
            };
            _this.IMG_OVERLAY_MAP = {
                1: '',
                2: 'content-dark',
                3: 'content-light',
            };
            _this.TEXT_ALIGN_MAP = {
                1: 'content-box-left',
                2: 'content-box-center',
                3: 'content-box-right',
            };
            _this.TEXT_COLOR_MAP = {
                1: 'content-color-text-dark',
                2: 'content-color-text-light',
            };
            _this.BTN_STYLE_MAP = {
                1: 'button-style-one',
                2: 'button-style-two',
            };
            _this.HTML_TAGS_REGEX = /<[^>]+>/gi;
            if (options) {
                _this.container = options.container;
            }
            _this.on('afterViewRender', function () {
                _this.$('img').on('load', function (event) {
                    var targetObj = $(event.target);
                    if (targetObj &&
                        targetObj[0] &&
                        targetObj[0].naturalHeight !== undefined) {
                        var imageElement = targetObj[0];
                        targetObj.parent().css('height', imageElement.naturalHeight);
                    }
                });
            });
            return _this;
        }
        ImageTextOverlayCCTView.prototype.install = function (settings, contextData) {
            _super.prototype.install.call(this, settings, contextData);
            this.logStyles();
            return jQuery.Deferred().resolve();
        };
        ImageTextOverlayCCTView.prototype.validateContextDataRequest = function () {
            return true;
        };
        ImageTextOverlayCCTView.prototype.getContext = function () {
            return {
                text: this.settings.custrecord_ns_sc_ext_ito_text,
                hasText: jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_text).replace(this.HTML_TAGS_REGEX, '') !== '',
                imageURL: jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_image_url),
                altText: jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_alttext),
                imgAlignClass: this.IMG_ALIGN_MAP[this.settings.custrecord_ns_sc_ext_ito_imgalignment],
                imgOverlayClass: this.IMG_OVERLAY_MAP[this.settings.custrecord_ns_sc_ext_ito_imgoverlay],
                opacityClass: !!this.IMG_OVERLAY_MAP[this.settings.custrecord_ns_sc_ext_ito_imgoverlay]
                    ? 'image-opacity'
                    : '',
                textAlignClass: this.TEXT_ALIGN_MAP[this.settings.custrecord_ns_sc_ext_ito_txtalignment],
                textColorClass: this.TEXT_COLOR_MAP[this.settings.custrecord_ns_sc_ext_ito_txtcolor],
                btnStyleClass: this.BTN_STYLE_MAP[this.settings.custrecord_ns_sc_ext_ito_btnstyle],
                btnText: jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_btntext),
                hasBtnText: !!jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_btntext),
                btnLink: jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_btnlink),
                target: jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_newwindow) === 'T'
                    ? '_blank'
                    : '_self',
            };
        };
        ImageTextOverlayCCTView.prototype.logStyles = function () {
            var imageAlignmentValue = +this.settings.custrecord_ns_sc_ext_ito_imgalignment;
            var imageAlignment;
            switch (imageAlignmentValue) {
                case 1:
                    imageAlignment = 'Top';
                    break;
                case 2:
                    imageAlignment = 'Center';
                    break;
                case 3:
                    imageAlignment = 'Bottom';
                    break;
            }
            Instrumentation_Helper_1.InstrumentationHelper.log('Usage of Image Alignment', imageAlignment);
            var imageOverlayValue = +this.settings.custrecord_ns_sc_ext_ito_imgoverlay;
            var imageOverlay;
            switch (imageOverlayValue) {
                case 1:
                    imageOverlay = 'None';
                    break;
                case 2:
                    imageOverlay = 'Dark';
                    break;
                case 3:
                    imageOverlay = 'Light';
                    break;
            }
            Instrumentation_Helper_1.InstrumentationHelper.log('Usage of Image Overlay', imageOverlay);
            var hasButton = !!jQuery.trim(this.settings.custrecord_ns_sc_ext_ito_btntext)
                ? 'true'
                : 'false';
            Instrumentation_Helper_1.InstrumentationHelper.log('Has Button', hasButton);
        };
        ImageTextOverlayCCTView.prototype.logButtonPress = function () {
            Instrumentation_Helper_1.InstrumentationHelper.log('Button pressed');
        };
        return ImageTextOverlayCCTView;
    }(CustomContentTypeBaseView));
    exports.ImageTextOverlayCCTView = ImageTextOverlayCCTView;
});
